import { LOGIN, GET_USER_NAME,GET_USER,LOGOUT_USER } from "../types/Types";

let initialState = {
  userName: "",
  loginUser: null,
  isUserLoggedIn: true,
};

function AuthReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER_NAME:
      return {
        ...state,
        userName: action.payload,
      };

    case LOGIN:
      return {
        ...state,
        isUserLoggedIn: true,
        loginUser: action.payload,
      };

    case GET_USER:
      return {
        ...state,
        isUserLoggedIn: true,
        loginUser: action.payload,
      };
      case LOGOUT_USER:
        return {
          ...state,
          isUserLoggedIn: false,
          loginUser: null
        };
        
    default:
      return state;
  }
}

export default AuthReducer;
